<div
    class="parallax-backgroundImage"
    *ngIf="subCategory?.sitecoreData?.backgroundImageLayer1"
    [ngStyle]="{ 'background-image': 'url(' + (subCategory?.sitecoreData?.backgroundImageLayer1?.src | sitecore_image_resize) + ')' }"></div>

<div
    cwdjParallax
    scrollerSelector="#casinocoreoverlay"
    *ngIf="subCategory?.sitecoreData?.backgroundImageLayer2"
    [config]="{ parallaxInitVal: 0 }"
    class="parallax-section parallax-image1"
    [ngStyle]="{ 'background-image': 'url(' + (subCategory.sitecoreData.backgroundImageLayer2.src | sitecore_image_resize) + ')' }"></div>

<div
    cwdjParallax
    scrollerSelector="#casinocoreoverlay"
    *ngIf="subCategory?.sitecoreData?.backgroundImageLayer3"
    [config]="{ parallaxInitVal: 0, parallaxRatio: -0.2, ratio: -0.2 }"
    class="parallax-blurImage parallax-section parallax-image2"
    [ngStyle]="{ 'background-image': 'url(' + (subCategory.sitecoreData.backgroundImageLayer3.src | sitecore_image_resize) + ')' }"></div>
